module.exports = __webpack_public_path__ + "img/LS20130912_greenfire_023.af9c444d.jpg";